import { get } from 'lodash'
import React from 'react'
import styled from 'styled-components'
import {
  VictoryChart,
  VictoryPolarAxis,
  VictoryArea,
  VictoryLine,
  VictoryScatter,
  VictoryVoronoiContainer,
  VictoryLabel
} from 'victory'
import { HSDScoreConfig } from './HSDSpiderGraph'

const GraphContainer = styled.div`
  margin-top: -80px;
`

const OFFSET_NAME_COMPARE_Y = [10, -5, -5]
const OFFSET_SORCE_COMPARE_Y = [25, 10, 10]
const SCORE_X = [0, 10, -10]
const LABEL_ANCHOR = ['middle', 'start', 'end']

export const HSDTriangleChart = (props) => {
  const triangles = [
    { y: 100, points: calculateTrianglePoints(100) },
    { y: 55.7, points: calculateTrianglePoints(55.7) },
    { y: 15, points: calculateTrianglePoints(15) }
  ]

  function calculateTrianglePoints(yValue) {
    const size = yValue
    return [
      { x: 0, y: size },
      { x: 1, y: size },
      { x: 2, y: size }
    ]
  }

  const domains = [
    {
      key: 'body_composition',
      name: 'BODY COMPOSITION'
    },
    {
      key: 'aerobic_fitness',
      name: 'AEROBIC FITNESS'
    },
    {
      key: 'muscular_fitness',
      name: 'MUSCLE FITNESS'
    }
  ]
  const data = domains.map((domain, index) => {
    const score =
      get(props, `${domain.key}.score_manual.value`) ||
      get(props, `${domain.key}.score_auto`)

    const config = score && HSDScoreConfig(score)
    return {
      x: index,
      y: score || 0,
      score: score,
      color: config ? config.color : 'rgba(77, 77, 77, 1)',
      text: config ? `${score} │ ${config.text}` : '--'
    }
  })

  return (
    <GraphContainer>
      <VictoryChart
        polar
        domain={{ y: [0, 100] }}
        startAngle={270}
        endAngle={630}
        containerComponent={
          <VictoryVoronoiContainer
            style={{
              touchAction: 'auto',
              height: '100%'
            }}
          />
        }
      >
        <VictoryArea
          style={{ data: { fill: 'rgba(186, 190, 199, 0.2)' } }}
          data={[100, 100, 100]}
        />
        <VictoryPolarAxis
          name="graph-score"
          labelPlacement="vertical"
          tickValues={[0, 1, 2]}
          tickFormat={(t) => data[t].text}
          tickLabelComponent={
            <VictoryLabel
              dx={(t) => SCORE_X[t]}
              dy={(t) => OFFSET_SORCE_COMPARE_Y[t || 0]}
              textAnchor={(t) => LABEL_ANCHOR[t]}
              inline
              style={[
                {
                  fill: (t = 0) => {
                    return data[t].color
                  },
                  fontSize: 10,
                  fontFamily: 'Gilroy',
                  fontWeight: 600
                }
              ]}
            />
          }
          style={{
            axis: { stroke: 'none' },
            grid: {
              stroke: 'rgba(119, 128, 139, 1)',
              strokeWidth: 1,
              strokeDasharray: '5,5'
            }
          }}
        />
        <VictoryPolarAxis
          name="graph-label"
          tickValues={[0, 1, 2]}
          tickFormat={(t) => domains[t].name.toUpperCase()}
          tickLabelComponent={
            <VictoryLabel
              dy={(y) => OFFSET_NAME_COMPARE_Y[y || 0]}
              dx={(t) => SCORE_X[t]}
              textAnchor={(t) => LABEL_ANCHOR[t]}
            />
          }
          labelPlacement="vertical"
          style={{
            axis: { stroke: 'none' },
            grid: {
              stroke: 'rgba(119, 128, 139, 1)',
              strokeWidth: 1,
              strokeDasharray: '5,5'
            },
            tickLabels: {
              fontSize: 8,
              fill: (t) => 'rgba(76,96,114,.6)'
            }
          }}
        />

        <VictoryPolarAxis
          dependentAxis
          style={{ axis: { stroke: 'none' } }}
          tickFormat={(t) => null}
        />
        {triangles.map((triangle, index) => (
          <VictoryLine
            key={index}
            data={triangle.points}
            style={{
              data: {
                stroke: index === 0 ? 'black' : 'rgba(119, 128, 139, 1)',
                strokeWidth: 1
              }
            }}
          />
        ))}

        <VictoryLine
          data={data}
          style={{
            data: { stroke: 'rgba(64, 196, 124, 1)', strokeWidth: 1 }
          }}
        />
        <VictoryArea
          style={{ data: { fill: 'rgba(180, 232, 195, 0.2)' } }}
          data={data}
        />
        <VictoryScatter
          data={data}
          style={{
            data: {
              stroke: (t) => t.color,
              strokeWidth: 2,
              fill: 'white'
            }
          }}
        />
      </VictoryChart>
    </GraphContainer>
  )
}
